import moment from 'moment';


class Utils {
  format_date(date, {with_time} = {}){
    const format = with_time ? this.DATE_FORMAT_WITH_TIME : this.DATE_FORMAT;
    return moment(date).format(format);
  }

  format_date_mysql(date){
    return moment(date).format(this.DATE_FORMAT_MYSQL);
  }

  TIME_FORMAT = 'HH:mm';
  DATE_FORMAT = 'DD-MM-YYYY';
  DATE_FORMAT_WITH_TIME = 'DD-MM-YYYY HH:mm';
  DATE_FORMAT_MYSQL = 'YYYY-MM-DD';

}

const utils = new Utils();


export default utils;